// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tzCM","comment":"styles_comment__3y8wv"};